import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Linkedin, Instagram } from "lucide-react";

export const CONTACT = {
  email: "info@translogexpress.com",
  email2: "sales@translogexpress.com",
  phone: "+91 22 4252 7200",
  phoneHref: "+912242527200",
  fax: "+91 22 4252 7222",
  address: "B 103-105, 1st Floor, Sagar Tech Plaza, Andheri Kurla Road, Saki Naka, Andheri (East), Mumbai – 400 072, India",
};

const CERTIFICATION_LOGOS = [
  { label: "IATA", src: "/assets/certs/IATA.jpeg" },
  { label: "MTO", src: "/assets/certs/MTO.png" },
  { label: "ACAAI", src: "/assets/certs/ACAAI.jpeg" },
  { label: "AEO", src: "/assets/certs/AEO.jpeg" },
  { label: "FIATA", src: "/assets/certs/FIATA.jpeg" },
  { label: "FFI", src: "/assets/certs/FFI.png" },
  { label: "SGS", src: "/assets/certs/SGS.jpeg" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer style={{ background: "#111111", color: "#ffffff" }} data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

        {/* Col 1 – Logo + tagline + description */}
        <div>
          <div className="flex flex-col items-start gap-0">
            <img
              src="/assets/RARE USE LOGO1.png"
              alt="Translog Express"
              className="block h-28 w-auto object-contain"
            //   style={{ filter: "brightness(0) invert(1)" }}
            />
          {/* Tagline */}
            <p className="mt-2 pb-3 text-[11px] leading-none font-semibold uppercase tracking-[0.15em] mb-0" style={{ color: "#DC2A1C" }}>
              Your Logistics Partner In India
            </p>
          </div>
          <p className="text-sm leading-relaxed" style={{ color: "#9ca3af" }}>
            Worldwide door-to-door freight forwarding. Air, ocean and customs clearance across 100+ countries since 2009.
          </p>
          <div className="flex gap-3 mt-5">
            {[
              { Icon: Facebook, href: "#" },
              { Icon: Linkedin, href: "#" },
              { Icon: Instagram, href: "#" },
            ].map(({ Icon, href }, i) => (
              <a
                key={i}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-lg flex items-center justify-center transition-colors"
                style={{ background: "rgba(255,255,255,0.08)" }}
                onMouseEnter={e => e.currentTarget.style.background = "#DC2A1C"}
                onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,0.08)"}
              >
                <Icon className="w-4 h-4 text-white" />
              </a>
            ))}
          </div>
        </div>

        {/* Col 2 – Quick links */}
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] font-semibold mb-4" style={{ color: "#DC2A1C" }}>Quick Links</h4>
          <ul className="space-y-2 text-sm" style={{ color: "#d1d5db" }}>
            <li><a href="/#home" className="hover:text-white transition-colors">Home</a></li>
            <li><a href="/#about" className="hover:text-white transition-colors">About Us</a></li>
            <li><a href="/#services" className="hover:text-white transition-colors">Services</a></li>
            <li><Link to="/updates" className="hover:text-white transition-colors">Updates</Link></li>
            <li><Link to="/#quote" className="hover:text-white transition-colors">Get a Quote</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link></li>
            <li><Link to="/important-links" className="hover:text-white transition-colors">Important Links</Link></li>
            <li><Link to="/login" className="hover:text-white transition-colors">Employee Portal</Link></li>
          </ul>
        </div>

        {/* Col 3 – Services */}
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] font-semibold mb-4" style={{ color: "#DC2A1C" }}>Services</h4>
          <ul className="space-y-2 text-sm" style={{ color: "#d1d5db" }}>
            <li><Link to="/services/air-freight" className="hover:text-white transition-colors">Air Freight</Link></li>
            <li><Link to="/services/ocean-freight" className="hover:text-white transition-colors">Ocean Freight</Link></li>
            <li><Link to="/services/import-consolidation-customs" className="hover:text-white transition-colors">Import Consolidation</Link></li>
            <li><Link to="/services/documentation-compliance" className="hover:text-white transition-colors">Documentation</Link></li>
            <li><Link to="/services/project-cargo" className="hover:text-white transition-colors">Project Cargo</Link></li>
            <li><Link to="/services/door-to-door" className="hover:text-white transition-colors">Door-to-Door</Link></li>
            <li><Link to="/services/dg-hazardous-valuable" className="hover:text-white transition-colors">DG and Hazardous Cargo</Link></li>
            <li><Link to="/services/cold-chain" className="hover:text-white transition-colors">Cold Chain Logistics</Link></li>
          </ul>
        </div>

        {/* Col 4 – Contact */}
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] font-semibold mb-4" style={{ color: "#DC2A1C" }}>Contact</h4>
          <ul className="space-y-3 text-sm" style={{ color: "#d1d5db" }}>
            <li className="flex gap-2 items-start">
              <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: "#DC2A1C" }} />
              <span>{CONTACT.address}</span>
            </li>
            <li className="flex gap-2 items-center">
              <Phone className="w-4 h-4 flex-shrink-0" style={{ color: "#DC2A1C" }} />
              <a href={`tel:${CONTACT.phoneHref}`} className="hover:text-white transition-colors" data-testid="footer-phone-link">{CONTACT.phone}</a>
            </li>
            <li className="flex gap-2 items-start">
              <Phone className="w-4 h-4 flex-shrink-0 mt-0.5" style={{ color: "#9ca3af" }} />
              <span style={{ color: "#9ca3af" }}>Fax: {CONTACT.fax}</span>
            </li>
            <li className="flex gap-2 items-center">
              <Mail className="w-4 h-4 flex-shrink-0" style={{ color: "#DC2A1C" }} />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors break-all" data-testid="footer-email-link">{CONTACT.email}</a>
            </li>
            <li className="flex gap-2 items-center">
              <Mail className="w-4 h-4 flex-shrink-0" style={{ color: "#DC2A1C" }} />
              <a href={`mailto:${CONTACT.email2}`} className="hover:text-white transition-colors break-all">{CONTACT.email2}</a>
            </li>
          </ul>
        </div>
      </div>

      {/* Certification & Membership badges */}
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5">
          <p className="text-center text-[10px] uppercase tracking-[0.25em] font-semibold mb-4" style={{ color: "rgba(255,255,255,0.35)" }}>
            Certifications &amp; Memberships
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2">
            {CERTIFICATION_LOGOS.map(({ label, src }) => (
              <div
                key={label}
                className="flex items-center justify-center rounded-xl px-1.5 py-1"
                style={{ background: "#ffffff", border: "1px solid rgba(255,255,255,0.08)" }}
              >
                <img
                  src={src}
                  alt={label}
                  className="h-10 w-auto max-w-[110px] object-contain"
                  loading="lazy"
                />
              </div>
            ))}
            {/* <span
              className="px-3 py-2 rounded-xl text-[11px] font-bold tracking-[0.1em] uppercase"
              style={{ background: "rgba(220,42,28,0.15)", color: "rgba(255,255,255,0.7)", border: "1px solid rgba(220,42,28,0.3)" }}
            >
              ISO 9001
            </span> */}
          </div>
        </div>
      </div>

      <div style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs" style={{ color: "#6b7280" }}>
          <p data-testid="copyright">© {year} TransLog Express Pvt. Ltd. All rights reserved.</p>
          <p>Made with ❤️ for global logistics</p>
        </div>
      </div>
    </footer>
  );
}
